module.exports = __webpack_public_path__ + "assets/img/ai-bg.63dbb98e.png";